import { Stack } from '@mui/material'
import apiManagerUser from 'api/manager-users'
import useLoginSSO from 'hooks/useLoginSSO'
import FormLoginWith2FA from 'pages/authentication/login/components/FormLoginWith2FA'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { endSession as logout } from 'store/sessionSlice'
import { toastError } from 'utils/helpers'
import { useAuthFlow } from '../../AuthFlowContext'

const LoginSSOWith2FA = ({isProvideService}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { sso, clearSSOFlow } = useAuthFlow()
    const { tempToken } = sso
    const { loginSSOSuccess } = useLoginSSO()

    const [isLoading, setIsLoading] = useState(false)
    const [waitTime, setWaitTime] = useState(0)
    const loadingTimerRef = useRef()

    const handleConfirmCode = async (data) => {
        setIsLoading(true)
        try {
            const res = await apiManagerUser.verifyLogin2FA({
                otp: data.code,
                is_backup_code: data.backup ? 1 : 0
            }, tempToken)

            if (res?.data.code === 0) {
                loginSSOSuccess(res.data.data, isProvideService)
                clearSSOFlow()
            } else if (res.data.code === 5) {
                toastError(t('toast.error.title.code2faError'))
            } else if (res.data.code === 2) {
                toastError(t('toast.error.title.expiredCode'))
                clearSSOFlow()
                dispatch(logout())
            } else if (res.data.code === 3) {
                setWaitTime(res.data.wait_time ?? 0)
            } else {
                toastError(t('toast.error.title.code2faError'))
            }
        } catch (error) {
            console.log(error)
        } finally {
            window.clearTimeout(loadingTimerRef.current)
            loadingTimerRef.current = window.setTimeout(() => setIsLoading(false), 1000)
        }
    }

    useEffect(() => () => window.clearTimeout(loadingTimerRef.current), [])

    return (
        <Stack sx={{ width: 500, margin: 'auto' }}>
            <FormLoginWith2FA handleConfirmCode={handleConfirmCode} isLoading={isLoading} waitTime={waitTime} setWaitTime={setWaitTime}/>
        </Stack>
    )
}

export default LoginSSOWith2FA
